import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

interface ProductCardWhatsIncludedImageProps extends ComponentProps<'img'> {
  /** Required: the artwork carries meaning about what the pass buys, so it is never decorative. */
  alt: string;
}

/**
 * The panel's artwork. Only the two day-pass panels have one; the sponsorship and Toronto Zoo Plus
 * panels are list-only, so this is rendered by the card rather than by the panel itself.
 */
const ProductCardWhatsIncludedImage = ({ className, alt, ...props }: ProductCardWhatsIncludedImageProps) => (
  <img
    alt={alt}
    width={301}
    height={208}
    className={cn('preflight preflight-img h-[208px] w-[301px] overflow-hidden rounded-lg object-cover', className)}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

export default ProductCardWhatsIncludedImage;
